export const SUPPORTED_YIELD_TOKENS = ["KYROS", "ZBTC", "ZEC", "XAUt0", "SPYx", "QQQx", "CRCLx", "BORG", "JUP", "OMNI", "NOMU", "BORGY", "SOLID"] as const;

export type SupportedYieldToken = (typeof SUPPORTED_YIELD_TOKENS)[number];

export const YIELD_TOKEN_IMAGES: Record<SupportedYieldToken, string> = {
    KYROS: "/kyros.svg",
    NOMU: "/nomu.png",
    BORGY: "/borgy.png",
    SOLID: "/solid.png",
    BORG: "/borg.png",
    ZBTC: "/zbtc.png",
    ZEC: "/zcash.png",
    XAUt0: "/xaut0.png",
    SPYx: "/spyx.png",
    QQQx: "/qqqx.png",
    CRCLx: "/crclx.png",
    JUP: "/jup.png",
    OMNI: "/omni.png",
};

export const YIELD_TOKEN_CONTRACTS: Record<SupportedYieldToken, string> = {
    ZBTC: "zBTCug3er3tLyffELcvDNrKkCymbPWysGcWihESYfLg",
    ZEC: "A7bdiYdS5GjqGFtxf17ppRHtDKPkkRqbKtR27dxvQXaS",
    XAUt0: "AymATz4TCL9sWNEEV9Kvyz45CHVhDZ6kUgjTJPzLpU9P",
    SPYx: "XsoCS1TfEyfFhfvj8EtZ528L3CaKBDBRqRapnBbDF2W",
    QQQx: "Xs8S1uUs1zvS2p7iwtsG3b6fkhpvmwz4GYU3gWAmWHZ",
    CRCLx: "XsueG8BtpquVJX9LVLLEGuViXUungE6WmK5YZ3p3bd1",
    KYROS: "kyrosJC2dtm6EoLV5wffZsS4RZVm2hRafKZCLsc38JE",
    NOMU: "NomuBwKJEvJ8d4dsaq7NZoHaXWXzKcfke1c7Y8ruFYL",
    BORGY: "BorGY4ub2Fz4RLboGxnuxWdZts7EKhUTB624AFmfCgX",
    SOLID: "SoLiDMWBct5TurG1LNcocemBK7QmTn4P33GSrRrcd2n",
    BORG: "3dQTr7ror2QPKQ3GbBCokJUmjErGg8kTJzdnYjNfvi3Z",
    JUP: "JUPyiwrYJFskUPiHa7hkeR8VUtAeFoSYbKedZNsDvCN",
    OMNI: "omfgRBnxHsNJh6YeGbGAmWenNkenzsXyBXm3WDhmeta",
};

export const MINT_TO_TOKEN: Record<string, SupportedYieldToken> = Object.fromEntries(
    Object.entries(YIELD_TOKEN_CONTRACTS).map(([name, mint]) => [mint, name as SupportedYieldToken])
);
